import axios from "axios";
import { server2 } from "../constant/config";
import { getChapters, getTopics } from "../constant/urls";
import { store } from "../constant/string";

const userStr = localStorage.getItem(store);

let userObj = null;
let token = null;

try {
  userObj = userStr ? JSON.parse(userStr) : null;
  token = userObj?.authenticationTOKEN || null;
} catch (error) {
  console.warn("Failed to parse user from localStorage:", error);
}

const config = {
  headers: {
    "Content-Type": "application/json",
    ...(token && { Authorization: `Bearer ${token}` }),
  },
};

async function addChapter(name, subject_id, board_id, class_id, name_english) {
  try {
    const response = await axios.post(
      `${server2}${getChapters}`,
      {
        name: name,
        subject_id: Number(subject_id),
        board_id: Number(board_id),
        class_id: Number(class_id),
        name_in_english: name_english,
      },
      config
    );
    return response.data;
  } catch (error) {
    throw error;
  }
}

async function addTopic(name, chapter_id, name_english) {
  try {
    const response = await axios.post(
      `${server2}${getTopics}`,
      {
        name: name,
        chapter_id: Number(chapter_id),
        name_in_english: name_english,
      },
      config
    );
    return response.data;
  } catch (error) {
    throw error;
  }
}
async function deleteQuestion(type, id) {
  try {
    const response = await axios.delete(`${server2}/v1/${type}/${id}`, config);
  } catch (error) {
    console.error(`Error deleting ${type} with ID ${id}:`, error);
    throw error;
  }
}
async function deleteChapter(id) {
  try {
    const response = await axios.delete(`${server2}/v1/chapters/${id}`, config);
  } catch (error) {
    console.error(`Error deleting chapter with ID ${id}:`, error);
    throw error;
  }
}
async function deleteTopic(id) {
  try {
    const response = await axios.delete(`${server2}/v1/topics/${id}`, config);
    return response;
  } catch (error) {
    console.error(`Error deleting topic with ID ${id}:`, error);
    throw error;
  }
}
async function addVideo(link, thumbnail, topic_id, sge_id, runTime) {
  try {
    const response = await axios.post(
      `${server2}/v1/videos`,
      {
        link: link,
        thumbnail: thumbnail,
        created_at: new Date().toISOString(),
        sge_id: Number(sge_id),
        runtime: Number(runTime),
      },
      config
    );
    const result = await axios.post(
      `${server2}/v1/videotopic`,
      {
        topic_id: Number(topic_id),
        video_id: response.data.videos.id,
      },
      config
    );
    return result.data;
  } catch (error) {
    throw error;
  }
}
async function fetchVideos(topicId) {
  try {
    const response = await axios.get(
      `${server2}/v1/videotopic?topicId=${topicId}`,
      config
    );
    return response.data.videos;
  } catch (error) {
    console.error("Error fetching videos:", error);
    throw error;
  }
}
async function fetchVideosData(videos) {
  try {
    const videoPromises = videos.map((video) =>
      axios.get(`${server2}/v1/videos/${video}`, config)
    );
    const videoResponses = await Promise.all(videoPromises);
    const videoData = videoResponses.map((response) => response.data.video);
    return videoData;
  } catch (error) {
    console.error("Error fetching videos data:", error);
    throw error;
  }
}

const addNotes = async (noteContent, topicId) => {
  try {
    const response = await axios.post(
      `${server2}/v1/notes`,
      {
        content: noteContent,
      },
      config
    );
    const note_id = response.data.note.id;
    const result = await axios.post(
      `${server2}/v1/notetopic`,
      {
        topic_id: Number(topicId),
        note_id: note_id,
      },
      config
    );
    return result.data;
  } catch (error) {
    console.error("Error adding notes:", error);
    throw error;
  }
};
async function fetchNotes(topicId) {
  try {
    const response = await axios.get(
      `${server2}/v1/notetopic?topicId=${topicId}`,
      config
    );
    return response.data.notes;
  } catch (error) {
    console.error("Error fetching notes:", error);
    throw error;
  }
}
async function fetchNotesData(notes) {
  try {
    const notesPromises = notes.map((note) =>
      axios.get(`${server2}/v1/notes/${note}`, config)
    );
    const noteResponses = await Promise.all(notesPromises);
    const noteData = noteResponses.map((response) => response.data.note);
    return noteData;
  } catch (error) {
    console.error("Error fetching note data:", error);
    throw error;
  }
}
async function deleteNote(id) {
  try {
    const response = await axios.delete(`${server2}/v1/notes/${id}`, config);
  } catch (error) {
    console.error(`Error deleting note with ID ${id}:`, error);
    throw error;
  }
}

const addWorksheet = async (link, description, topicId) => {
  try {
    const response = await axios.post(
      `${server2}/v1/worksheets`,
      {
        link: link,
        description: description,
      },
      config
    );
    const worksheet_id = response.data.worksheet.id;
    const result = await axios.post(
      `${server2}/v1/worksheettopic`,
      {
        topic_id: Number(topicId),
        worksheet_id: worksheet_id,
      },
      config
    );
    return result.data;
  } catch (error) {
    console.error("Error adding worksheet:", error);
    throw error;
  }
};

async function fetchWorksheets(topicId) {
  try {
    const response = await axios.get(
      `${server2}/v1/worksheettopic?topicId=${topicId}`,
      config
    );
    return response.data.worksheets;
  } catch (error) {
    console.error("Error fetching worksheets:", error);
    throw error;
  }
}
async function fetchtWorksheetsData(worksheets) {
  try {
    const worksheetsPromises = worksheets?.map((worksheet) =>
      axios.get(`${server2}/v1/worksheets/${worksheet}`, config)
    );
    const worksheetsResponses = worksheetsPromises
      ? await Promise.all(worksheetsPromises)
      : [];
    const worksheetData = worksheetsResponses.map(
      (response) => response.data.worksheet
    );
    return worksheetData;
  } catch (error) {
    console.error("Error fetching worksheeet data:", error);
    throw error;
  }
}
async function deleteWorksheetById(id) {
  try {
    const response = await axios.delete(
      `${server2}/v1/worksheets/${id}`,
      config
    );
  } catch (error) {
    console.error(`Error deleting note with ID ${id}:`, error);
    throw error;
  }
}
async function modifyNote(noteId, noteContent) {
  try {
    await axios.patch(
      `${server2}/v1/notes/${noteId}`,
      {
        content: noteContent,
      },
      config
    );
    return { success: true, message: "Note modified successfully" };
  } catch (error) {
    console.error("Error modifying note:", error);
    throw error;
  }
}

const convertSelectionToImageTag = (
  content,
  selectionStart,
  selectionEnd,
  setContent,
  textareaRef
) => {
  // Get the selected text
  const selectedText = content.substring(selectionStart, selectionEnd);

  // Check if the selected text is an image URL
  const isImageUrl = (url) => {
    return (
      /\.(jpg|jpeg|png|gif|webp|svg|bmp)$/i.test(url.split("?")[0]) ||
      url.startsWith("data:image/") ||
      url.includes("storage.googleapis.com")
    );
  };

  if (!isImageUrl(selectedText)) {
    return { newContent: content, newCursorPos: selectionEnd };
  }

  // Create the image tag
  const imgTag = `<img style="max-width: 100%;" src="${selectedText}" alt="uploaded image" />`;

  // Insert the image tag
  const newContent =
    content.substring(0, selectionStart) +
    imgTag +
    content.substring(selectionEnd);

  // Calculate new cursor position (after the inserted image tag)
  const newCursorPos = selectionStart + imgTag.length;
  const textarea = textareaRef.current;
  const scrollPos = textarea ? textarea.scrollTop : 0;
  // Update content
  setContent(newContent);

  // Focus and position cursor
  requestAnimationFrame(() => {
    if (textarea) { 
      textarea.focus();
      textarea.selectionStart = newCursorPos;
      textarea.selectionEnd = newCursorPos;
      textarea.scrollTop = scrollPos;
    }
  })

  return { newContent, newCursorPos };
};

const fetchSubjectName = async (subjectId) => {
  try {
    const response = await axios.get(
      `${server2}/v1/subjects/${subjectId}`,
      config
    );
    return response.data.subjects.name;
  } catch (error) {
    console.error("Error fetching subject name:", error);
    throw error;
  }
};
const boardLanguage = async (board_id) => {
  try {
    const response = await axios.get(
      `${server2}/v1/boards/${board_id}`,
      config
    );
    return {
      language: response.data.board.language,
      name: response.data.board.name,
    };
  } catch (error) {
    console.error("Error fetching board language:", error);
    throw error;
  }
};
const fetchSavedAiAnswer = async (questionId, questionType) => {
  try {
    const response = await axios.get(
      `${server2}/v1/question?id=${questionId}&type=${questionType}`,
      config
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching saved AI answer:", error);
    throw error;
  }
};
const getProbabilityColor = (probability) => {
  if (probability >= 0.8) return "text-green-600 bg-green-100";
  if (probability >= 0.6) return "text-yellow-600 bg-yellow-100";
  if (probability >= 0.4) return "text-orange-600 bg-orange-100";
  return "text-red-600 bg-red-100";
};

export {
  addChapter,
  addTopic,
  deleteQuestion,
  deleteChapter,
  deleteTopic,
  addVideo,
  fetchVideos,
  fetchVideosData,
  addNotes,
  fetchNotes,
  fetchNotesData,
  deleteNote,
  addWorksheet,
  fetchWorksheets,
  fetchtWorksheetsData,
  deleteWorksheetById,
  modifyNote,
  userObj,
  convertSelectionToImageTag,
  fetchSubjectName,
  boardLanguage,
  fetchSavedAiAnswer,
  getProbabilityColor,
};

// --- Weekly Test (operator authoring) — /v1/wt/admin/* (SGGOD) ---
export const listWTEvents = async () => {
  const res = await axios.get(`${server2}/v1/wt/admin/events`, config);
  return res.data.events || [];
};

export const createWTEvent = async (body) => {
  const res = await axios.post(`${server2}/v1/wt/admin/events`, body, config);
  return res.data.event;
};

export const getWTEvent = async (id) => {
  const res = await axios.get(`${server2}/v1/wt/admin/events/${id}`, config);
  return res.data.event;
};

export const addWTQuestion = async (eventId, body) => {
  const res = await axios.post(
    `${server2}/v1/wt/admin/events/${eventId}/questions`,
    body,
    config
  );
  return res.data.question;
};

export const removeWTQuestion = async (eventId, eqId) => {
  await axios.delete(
    `${server2}/v1/wt/admin/events/${eventId}/questions/${eqId}`,
    config
  );
};

export const fetchBoards = async () => {
  const res = await axios.get(`${server2}/v1/boards`, config);
  return res.data.boards || [];
};

export const fetchClasses = async () => {
  const res = await axios.get(`${server2}/v1/classes`, config);
  return res.data.classes || [];
};

export const updateWTQuestion = async (id, body) => {
  const res = await axios.patch(
    `${server2}/v1/wt/admin/questions/${id}`,
    body,
    config
  );
  return res.data;
};

export const fetchSubjects = async () => {
  const res = await axios.get(`${server2}/v1/subjects`, config);
  return res.data.subjects || [];
};

// Round builder (Phase 1): resolve a cohort plan, then auto-build the events.
export const resolveWTRound = async (spec) => {
  const res = await axios.post(
    `${server2}/v1/wt/admin/rounds/resolve`,
    spec,
    config
  );
  return res.data.resolution;
};

export const buildWTRound = async (spec, dryRun = false) => {
  const res = await axios.post(
    `${server2}/v1/wt/admin/rounds/build${dryRun ? "?dry_run=true" : ""}`,
    spec,
    config
  );
  return res.data.build;
};

export const fetchWTChapters = async (boardId, classId, subjectId) => {
  const res = await axios.get(
    `${server2}/v1/wt/admin/chapters?board_id=${boardId}&class_id=${classId}&subject_id=${subjectId}`,
    config
  );
  return res.data.chapters || [];
};

// The classes + (class,subject) pairs that have chapters for the given boards, so
// the round wizard offers only valid class-block / subject-id combos (Hindi boards
// use class 16/17 + गणित #33, CBSE uses 9/10 + Maths #1).
export const fetchWTBoardCatalog = async (boards) => {
  const res = await axios.get(
    `${server2}/v1/wt/admin/board-catalog?boards=${boards.join(",")}`,
    config
  );
  return res.data.catalog || { classes: [], subjects: [] };
};

export const fetchWTCohortTemplates = async () => {
  const res = await axios.get(
    `${server2}/v1/wt/admin/cohort-templates`,
    config
  );
  return res.data.cohorts || [];
};

// Create the round's prod SHELLS (events+sections, no questions). closesAt is the
// dev round key; prodOpensAt/prodClosesAt is the prod window.
export const publishWTShells = async (closesAt, prodOpensAt, prodClosesAt) => {
  const res = await axios.post(
    `${server2}/v1/wt/admin/rounds/publish-shells`,
    {
      closes_at: closesAt,
      prod_opens_at: prodOpensAt,
      prod_closes_at: prodClosesAt,
    },
    config
  );
  return res.data.shells;
};

// Copy the round's QUESTIONS + links into the prod shells (Phase 3b). closesAt is
// the dev round key; prodOpensAt must match the published shells' opens_at. Pass
// dryRun=true to preview (prod resolves + stages the inserts, then rolls back).
export const publishWTQuestions = async (closesAt, prodOpensAt, dryRun) => {
  const res = await axios.post(
    `${server2}/v1/wt/admin/rounds/publish-questions`,
    {
      closes_at: closesAt,
      prod_opens_at: prodOpensAt,
      dry_run: !!dryRun,
    },
    config
  );
  return res.data.import;
};

// Phase 2 — solutions + QA gate (operate on the dev round by closes_at).
// Kick off the async Gemini solution-fill job (returns immediately; poll QA).
export const generateWTSolutions = async (closesAt) => {
  const res = await axios.post(
    `${server2}/v1/wt/admin/rounds/generate-solutions`,
    { closes_at: closesAt },
    config
  );
  return res.data;
};

// Strip leftover HTML/entities from the round's questions/options/solutions.
export const cleanWTRound = async (closesAt) => {
  const res = await axios.post(
    `${server2}/v1/wt/admin/rounds/clean`,
    { closes_at: closesAt },
    config
  );
  return res.data.cleaned;
};

// Run the content QA gate (read-only) — returns counts + per-check pass/fail.
export const fetchWTRoundQA = async (closesAt) => {
  const res = await axios.post(
    `${server2}/v1/wt/admin/rounds/qa`,
    { closes_at: closesAt },
    config
  );
  return res.data.qa;
};
